import { render, staticRenderFns } from "./StocProfile.vue?vue&type=template&id=a4629b72&scoped=true"
import script from "./StocProfile.vue?vue&type=script&lang=js"
export * from "./StocProfile.vue?vue&type=script&lang=js"
import style0 from "./StocProfile.vue?vue&type=style&index=0&id=a4629b72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4629b72",
  null
  
)

export default component.exports